import { ISingleTag } from 'components/Tags/SingleTag';
import Tag, { TagSystemTypes } from 'models/tag';
import { apiGetTags } from 'services/Api/tagService';
import { apiRequest } from 'services/Auth/authConfig';
import { EntityCache, ICache } from './entityCache';

export class TagCache extends EntityCache<Tag> implements ICache<Tag, TagCache> {
  private isLoading: boolean = false;

  private tagsPromise: Promise<Tag[]> | undefined;

  constructor() {
    super();
    this.getId = (tag) => tag.tagId;
    this.getEmptyItem = () => Tag.getEmptyTag();
  }

  getFirstForGroup(group: string): Tag | undefined {
    const groupLower = group.toLowerCase();
    const tag = this.items?.find((i) => i.tagName.toLowerCase() === groupLower);

    return tag;
  }

  getForValue(group: string, value: string): Tag | undefined {
    const groupLower = group.toLowerCase().trim();
    const valueLower = value.toLowerCase().trim();
    const tag = this.items?.find(
      (i) => i.tagName.toLowerCase() === groupLower && i.tagValue.toLowerCase() === valueLower,
    );

    return tag;
  }

  async getItems(refresh: boolean = false): Promise<Tag[]> {
    if (this.isLoading && this.tagsPromise) {
      return await this.tagsPromise;
    }

    if (this.items.length === 0 || refresh) {
      if (this.appContext && !this.isLoading) {
        try {
          const accessToken = await this.appContext.getAccessToken(apiRequest.scopes);
          this.tagsPromise = apiGetTags(false, accessToken);
          this.isLoading = true;
          this.items = await this.tagsPromise;
        } catch (err) {
          this.appContext.setError(err);
        } finally {
          this.isLoading = false;
          this.tagsPromise = undefined;
        }
      } else if (!this.appContext) {
        this.items = [];
      }
    }

    return this.items;
  }

  getGroups(): ISingleTag[] {
    const groups: ISingleTag[] = [];

    this.items.forEach((t) => {
      if (groups.findIndex((k) => k.tagName === t.tagName) === -1) {
        const newKey: ISingleTag = {
          tagId: t.tagId,
          tagName: t.tagName,
          tagColor: t.tagColor,
        };
        groups.push(newKey);
      }
    });

    return groups;
  }

  getGroupNamesForSystemType(type: TagSystemTypes): string[] {
    return [...new Set(this.items.filter((i) => i.tagSystemType === type).map((i) => i.tagName))];
  }

  getItemsForSystemType(type: TagSystemTypes): Tag[] {
    return this.items.filter((i) => i.tagSystemType === type);
  }

  clone(): TagCache {
    const tagCache: TagCache = new TagCache();
    tagCache.items = this.items?.map((u) => u.clone());

    return tagCache;
  }
}
